import { useMemo } from "react";
import type { FC } from "react";
import type { VehicleLike } from "../../types/VehicleTypes";

export const AttachedCar: FC<{
  car: VehicleLike;
  getVehicleDetails: (carId: string) => void;
  clearAttachedCar: () => void;
}> = ({ car, clearAttachedCar, getVehicleDetails }) => {
  const title = useMemo(() => {
    const v: any = car as any;
    return [v.marque, v.modele, v.version].filter(Boolean).join(" ");
  }, [car]);

  const photoSrc = (car as any)?.photos?.[0]?.src as string | undefined;

  return (
    <div
      className="vcw-attached-vehicle"
      role="region"
      aria-label="Véhicule attaché"
      onClick={() => getVehicleDetails(car._id)}
    >
      <div className="vcw-attached-vehicle__left">
        {photoSrc ? (
          <img
            className="vcw-attached-vehicle__image"
            src={photoSrc}
            alt={title || "Véhicule"}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div
            className="vcw-attached-vehicle__imagePlaceholder"
            aria-hidden="true"
          />
        )}
      </div>

      <div className="vcw-attached-vehicle__right">
        <div className="vcw-attached-vehicle__title" title={title}>
          {title || "Véhicule sélectionné"}
        </div>

        <button
          type="button"
          className="vcw-attached-vehicle__close"
          onClick={(e) => {
            e.stopPropagation();
            clearAttachedCar();
          }}
          aria-label="Fermer le bandeau du véhicule"
        >
          ×
        </button>
      </div>
    </div>
  );
};
